import { Portfolio, PortfolioCategory } from "../../models";
import { makeActionCreator } from "../../store/types";

export const SET_PORTFOLIOS = "portfolio/SET_PORTFOLIOS";
export const SET_CATEGORIES = "portfolio/SET_CATEGORIES";
export const SET_CHOSEN_CATEGORY = "portfolio/SET_CHOSEN_CATEGORY";

export const setChosenCategory = makeActionCreator<number>(SET_CHOSEN_CATEGORY);
export const setPortfolios = makeActionCreator<Portfolio[]>(SET_PORTFOLIOS);
export const setCategories = makeActionCreator<PortfolioCategory[]>(
  SET_CATEGORIES,
);

export const fetchCategories = () => async (dispatch, _, http) => {
  try {
    const result: any = await http.get("data/portfolio_categories");
    dispatch(setCategories(result.portfolio_categories));
  } catch (error) {
    throw error;
  }
};

export const fetchPortfolios = () => async (dispatch, _, http) => {
  try {
    const result: any = await http.get("data/portfolios");
    dispatch(setPortfolios(result.portfolios));
  } catch (error) {
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/routes/PortfolioCarousel/actions.ts